import useOrganisationFeatures, { type OrganisationFeature } from './useOrganisationFeatures';

export interface PlusFeatureAccess {
  hasAccess: boolean | undefined;
  /**
   * Support switched the feature off for this organisation in PAM. Unlike a feature the plan
   * leaves out, a hidden feature is not upsold: its page, sidebar item and promos disappear.
   */
  isHidden: boolean;
  isLoading: boolean;
  isError: boolean;
  retry: () => void;
}

export default function useHasPlusFeature(
  feature: OrganisationFeature,
  hasAccessToday: boolean
): PlusFeatureAccess {
  const { pricingLaunched, hasFeature, isFeatureHidden, isLoading, isError, retry } =
    useOrganisationFeatures();

  if (isLoading || isError) {
    return { hasAccess: undefined, isHidden: false, isLoading, isError, retry };
  }

  return {
    hasAccess: pricingLaunched ? hasFeature(feature) : hasAccessToday,
    isHidden: pricingLaunched && isFeatureHidden(feature),
    isLoading: false,
    isError: false,
    retry,
  };
}
